import { Routes } from '@angular/router';

import { FullComponent } from './layouts/full/full.component';
import { LoginComponent } from './pages/login/login.component';
import { authGuard } from './services/auth.guard';

export const AppRoutes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'admin',
    canActivate: [authGuard],
    data: {roles: ['watchdog-admin-console-access']},
    component: FullComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./pages/results/results.module').then(m => m.ResultsModule)
      },
      {
        path: 'templates',
        loadChildren: () => import('./pages/templates/templates.module').then(m => m.TemplatesModule)
      },
      {
        path: 'studio',
        loadComponent: () => import('./pages/studio/test-studio.component').then(c => c.TestStudioComponent)
      },
      {
        path: 'studio-chat',
        loadComponent: () => import('./pages/studio/studio-chat.component').then(c => c.StudioChatComponent)
      },
      {
        path: 'suite',
        loadComponent: () => import('./pages/studio/auto-suite.component').then(c => c.AutoSuiteComponent)
      },
      {
        path: 'api-suite',
        loadComponent: () => import('./pages/studio/api-suite.component').then(c => c.ApiSuiteComponent)
      },
      {
        path: 'runs',
        loadComponent: () => import('./pages/results/suite-runs/suite-runs.component').then(c => c.SuiteRunsComponent)
      },
      {
        path: 'schedule',
        loadChildren: () => import('./pages/control/control.module').then(m => m.ControlModule)
      },
      {
        path: 'system-config',
        data: {roles: ['watchdog-admin-console-system-config']},
        loadChildren: () => import('./system-config/system-config.module').then(m => m.SystemConfigModule)
      },
      {
        path: 'settings',
        loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule)
      },
      {
        path: 'users',
        loadChildren: () => import('./pages/users/users.module').then(m => m.UsersModule)
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'admin/dashboard'
  },
];
